module.exports = __webpack_public_path__ + "img/flag-red.dbe083f5.svg";